/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum APIAccessLevel {
  User = 'User',
  SuperVisor = 'SuperVisor',
  Admin = 'Admin',
  ReadOnly = 'ReadOnly',
}

export interface APIAdditiveModel {
  /**
   * The unique identifier of the additive
   * @format int32
   */
  id: number;
  /**
   * The name of the additive
   * @minLength 1
   */
  name: string;
}

export interface APIAdditiveRequestModel {
  /** @format int32 */
  id: number;
  /** @minLength 1 */
  name: string;
}

export interface APIAdditiveSearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: null | any[];
  /** The search parameter that indicates the Mix Type name to search */
  name?: null | string;
  /** The search parameter for the category to search */
  categoryIds?: null | any[];
  /** The search parameter that indicates if the additive is project specific */
  isProjectSpecific?: boolean;
}

export interface APIAdditiveUsageModel {
  /**
   * The unique identifier of the company
   * @format uuid
   */
  id: string;
  /**
   * The name of the company
   * @minLength 1
   */
  name: string;
}

export interface APIAfterHoursResponseModel {
  isWorkingHours?: boolean;
  message?: null | string;
  /** @format double */
  startAfter?: number;
}

export interface APIApplicationVersionModel {
  version?: null | string;
  notes?: null | string;
  isForceUpdate?: boolean;
}

export interface APIAssignedDriverModel {
  /**
   * Unique identifier for the assignment.
   * @format int32
   */
  id: number;
  driver: APIUserModel;
  plant: APIPlantModel;
  /**
   * Date and timr when the driver was assigned to the plant.
   * @format date-time
   */
  assignDate: string;
  /**
   * Date and time when the driver was notified about the assignment
   * @format date-time
   */
  notifiedDate?: null | string;
}

export interface APIAssignedDriverRequestModel {
  /** @format uuid */
  driverId: string;
  /** @format uuid */
  plantId: string;
  /** @format date-time */
  assignDate: string;
}

export interface APIAutocompleteResult {
  description?: null | string;
  placeId?: null | string;
}

export interface APIAvailableAdditiveModel {
  /**
   * The unique identifier of the additive
   * @format int32
   */
  id: number;
  /**
   * The name of the additive
   * @minLength 1
   */
  name: string;
  /**
   * The providerId of the mix type
   * @format uuid
   */
  providerId: string;
  /**
   * Number of projects where mix type is used
   * @format int32
   */
  usage: number;
  /**
   * The categoryId of the mix type
   * @format int32
   */
  categoryId: number;
  /**
   * The category name of the mix type
   * @minLength 1
   */
  categoryName: string;
}

export interface APIAvailableAdditiveModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * The count of the searched entities in the DB
   * @format int32
   * @example 1
   */
  count?: number;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APIAvailableAdditiveSearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: null | any[];
  /** The search parameter that indicates the Additive name to search */
  name?: null | string;
}

export interface APIAvailableMixTypeModel {
  /**
   * The unique identifier of the mix type
   * @format int32
   */
  id: number;
  /**
   * The name of the mix type
   * @minLength 1
   */
  name: string;
  /**
   * The providerId of the mix type
   * @format uuid
   */
  providerId: string;
  /**
   * Number of projects where mix type is used
   * @format int32
   */
  usage: number;
  /**
   * The categoryId of the mix type
   * @format int32
   */
  categoryId: number;
  /**
   * The category name of the mix type
   * @minLength 1
   */
  categoryName: string;
}

export interface APIAvailableMixTypeModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * The count of the searched entities in the DB
   * @format int32
   * @example 1
   */
  count?: number;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APIAvailableMixTypeSearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: null | any[];
  /** The search parameter that indicates the Mix Type name to search */
  name?: null | string;
}

export interface APIBaseTicketModel {
  ticketNumber?: null | string;
  orderThirdPartyId?: null | string;
  plantThirdPartyId?: null | string;
  truckThirdPartyId?: null | string;
  driverThirdPartyId?: null | string;
  /** @format double */
  batchSize?: number;
  isVoided?: boolean;
  serviceName?: null | string;
}

export enum APICallBackFormStatus {
  CallbackPending = 'CallbackPending',
  NoCallback = 'NoCallback',
  CallbackSubmitted = 'CallbackSubmitted',
  CallbackConfirmed = 'CallbackConfirmed',
  CallbackAutoResolved = 'CallbackAutoResolved',
}

export enum APICategoryType {
  Additive = 'Additive',
  MixType = 'MixType',
}

export enum APIChangesStatus {
  Declined = 'Declined',
  Pending = 'Pending',
  Applied = 'Applied',
}

export interface APIChatMessageModel {
  /**
   * The unique identifier of the chat message.
   * @format uuid
   */
  id: string;
  /**
   * The unique identifier of the order associated with this message.
   * @format int32
   */
  orderId: number;
  /**
   * The date and time when the message was created.
   * @format date-time
   */
  createdOn: string;
  /**
   * The content of the chat message.
   * @minLength 1
   */
  message: string;
  /**
   * The unique identifier of the user who sent the chat message.
   * @format uuid
   */
  senderId: string;
  /**
   * The first name of the user who sent the chat message.
   * @minLength 1
   */
  senderFirstName: string;
  /**
   * The last name of the user who sent the chat message.
   * @minLength 1
   */
  senderLastName: string;
  /**
   * The user type of a sender
   * @minLength 1
   */
  senderUserType: string;
  /**
   * The user access level
   * @minLength 1
   */
  senderAccessLevel: string;
  /**
   * The unique identifier of the attachments associated with the chat message.
   * @uniqueItems true
   */
  attachmentIds?: null | any[];
}

export interface APIChatMessageModelContinueSearchResult {
  /**
   * The continue token for search
   * @example 1
   */
  token?: null | string;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APICompanyAdditiveRequestModel {
  /** The unique identifiers of the mix types */
  ids: number[];
}

export interface APICompanyMixTypeRequestModel {
  /** The unique identifiers of the mix types */
  ids: number[];
}

export interface APICompanyModel {
  /**
   * The unique identifier for the company
   * @format uuid
   * @example "628ffc50-56c7-4b30-a752-9d9438cbc51a"
   */
  id: string;
  /**
   * The name of the company (should be unique)
   * @minLength 1
   * @maxLength 500
   * @example "Proxet"
   */
  name: string;
  /**
   * The physical address of the company
   * @minLength 1
   * @maxLength 500
   * @example "Kyiv. Honcharna St. 2, Kyiv, Ukraine 04071"
   */
  address: string;
  /**
   * The unique identifier of the provider where the company is located.
   * @format uuid
   */
  providerId: string;
  /**
   * Shows when company was created
   * @format date-time
   */
  createdDate?: null | string;
  companyType: APIUserType;
  /** Shows if company is deleted */
  isDeactivated: boolean;
  /**
   * Shows if when company was deleted
   * @format date-time
   */
  deactivatedDate?: null | string;
  /** Shows if company can be deleted */
  inUse: boolean;
}

export interface APICompanyModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * The count of the searched entities in the DB
   * @format int32
   * @example 1
   */
  count?: number;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APICompanyRequestModel {
  /**
   * The name of the company (should be unique)
   * @minLength 1
   * @example "Proxet"
   */
  name: string;
  /**
   * The physical address of the company
   * @maxLength 500
   * @example "Kyiv. Honcharna St. 2, Kyiv, Ukraine 04071"
   */
  address?: null | string;
  companyType: APIUserType;
  /** Flag if company is deactivated */
  isDeactivated?: boolean;
}

export interface APICompanySearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: null | any[];
  /**
   * The search parameter for the company name
   * @example "Company name"
   */
  name?: null | string;
  companyType?: APIUserType;
  /**
   * Include inactive companies
   * @example true
   */
  includeDeactivated?: boolean;
}

export interface APICorrectionEmailModel {
  /**
   * Text to be send in email
   * @minLength 1
   */
  text: string;
}

export enum APICustomFieldType {
  Text = 'Text',
  Number = 'Number',
  Boolean = 'Boolean',
  Date = 'Date',
}

export enum APIDeliveryRateType {
  MinTruck = 'MinTruck',
  CyHour = 'CyHour',
}

export interface APIDialogModel {
  /** @format int32 */
  orderId?: number;
  orderName?: null | string;
  orderStatus?: APIOrderStatus;
  /** @format date-time */
  updatedOn?: string;
  /** @format int64 */
  ticks?: number;
  /** @format date-time */
  createdOn?: string;
  /** @format uuid */
  companyId?: string;
  companyName?: null | string;
  /** @format uuid */
  providerId?: string;
  /** @format uuid */
  lastMessageSenderId?: string;
  lastMessage?: null | string;
  lastMessageUserType?: null | string;
  isReadByCustomer?: boolean;
  /** @uniqueItems true */
  readCustomerIds?: null | any[];
  isReadByDispatcher?: boolean;
  markAsReadBy?: APIMarkAsReadByUser;
  highlights?: null | object;
}

export interface APIDialogModelContinueSearchResult {
  /**
   * The continue token for search
   * @example 1
   */
  token?: null | string;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APIDigitalFleetEvent {
  /** Indicates the general type of update.  Will be one of TRUCK, TICKET, or POSITION. */
  eventType?: null | string;
  /**
   * UTC time stamp of the event, using ISO-8601 formatting
   * @format date-time
   */
  eventTime?: string;
  /**
   * Direction truck is travelling, as reported by GPS.  In degrees.
   * @format double
   */
  heading?: null | number;
  /**
   * Current latitude of truck, as reported by GPS.
   * @format double
   */
  longitude?: null | number;
  /**
   * Current longitude of truck, as reported by GPS.
   * @format double
   */
  latitude?: null | number;
  /**
   * Unique ID for this event.  Always present
   * @format int32
   */
  messageId?: null | number;
  /** Order number/ID for ticket being updated. */
  orderNumber?: null | string;
  /**
   * Current speed truck is travelling, as reported by GPS.
   * @format double
   */
  speed?: null | number;
  /** Unit in which “Speed” field is measured.  Always “MPH” for miles per hour (but may be variable in future versions). */
  speedUom?: null | string;
  ticketEventCode?: APITicketEventCode;
  /**
   * Digital Fleet ticket ID for ticket being updated.
   * @format int32
   */
  ticketId?: number;
  /** Ticket number being updated. */
  ticketNumber?: null | string;
  ticketStatusCode?: APITicketStatusCode;
  ticketType?: APITicketType;
  /** Identifier for the statusing truck */
  truckName?: null | string;
}

export interface APIDigitalFleetEventData {
  version?: null | string;
  events?: null | any[];
}

export interface APIDriverTrackingModel {
  /**
   * The unique identifier for the user
   * @format uuid
   * @example "628ffc50-56c7-4b30-a752-9d9438cbc51a"
   */
  id: string;
  /**
   * The first name of the user
   * @minLength 1
   * @example "Alex"
   */
  firstName: string;
  /**
   * The last name of the user
   * @minLength 1
   * @example "Stock"
   */
  lastName: string;
  /**
   * The email address of the user which will be used for login, should be unique
   * @minLength 1
   * @example "alex.stock@cd3p.app"
   */
  email: string;
  /**
   * The phone number of the user which will be for notifications
   * @minLength 1
   * @example "+18571234675"
   */
  phone: string;
  userType: APIUserType;
  userStatus?: APIUserStatus;
  accessLevel: APIAccessLevel;
  /** The list of providers for which user has access */
  providers?: null | any[];
  /** The list of companies where the user belongs */
  companies?: null | any[];
  /** The third party id of the user */
  thirdPartyId?: null | string;
  /** The gps tracking system id of the user */
  gpsTrackingId?: null | string;
  /** The token for authorization */
  token?: null | string;
  /** The temporary token for authorization */
  temporaryToken?: null | string;
  /** Version of cache stored on the user device */
  globalCacheVersion?: null | string;
  /** The list of user options */
  userOptions?: null | object;
  newApplicationVersions?: null | any[];
  /** @format date-time */
  lastUpdate?: string;
}

export interface APIDriverTrackingModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * The count of the searched entities in the DB
   * @format int32
   * @example 1
   */
  count?: number;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APIEmptySearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
}

export interface APIEmptySortableSearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: null | any[];
}

export interface APIEntityHistoryModel {
  /**
   * The unique identifier of the entity
   * @minLength 1
   */
  entityId: string;
  entityType: APIEntityType;
  /**
   * The timestamp of the change
   * @format date-time
   */
  timeStamp: string;
  /**
   * The name of the field that was changed
   * @minLength 1
   */
  fieldName: string;
  /**
   * The new value of the field after the change
   * @minLength 1
   */
  fieldValue: string;
  /**
   * The id of user who made changes
   * @format uuid
   */
  createdById?: null | string;
  changesStatus: APIChangesStatus;
}

export interface APIEntityHistoryModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * The count of the searched entities in the DB
   * @format int32
   * @example 1
   */
  count?: number;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APIEntityHistorySearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** The search parameter for entity id */
  entityId?: null | string;
  entityType?: APIEntityType;
}

export enum APIEntityType {
  Order = 'Order',
  Ticket = 'Ticket',
  Truck = 'Truck',
  Project = 'Project',
  UserManagement = 'UserManagement',
  TeamUser = 'TeamUser',
}

export interface APIForgotPasswordRequestModel {
  /**
   * Email for the forgotten password form
   * @minLength 1
   */
  email: string;
}

export interface APIFullTextSearchFilter {
  /** The global search query for the full text search */
  pattern?: null | string;
  /** The Columns to search in the full text search */
  columns?: null | any[];
}

export interface APIGuidTypeaheadModel {
  /**
   * The item id
   * @format uuid
   */
  id?: string;
  /**
   * The name of an item
   * @example "TestName"
   */
  name?: null | string;
}

export interface APIGuidTypeaheadRequestModel {
  /** The value pattern to search */
  query?: null | string;
  /**
   * The number of result items to return
   * @format int32
   * @example 5
   */
  count?: number;
  /** Ids to exclude from search result */
  excludedIds?: null | any[];
}

/** Represents a help request. */
export interface APIHelpRequestModel {
  /**
   * Gets or sets the body of the help request.
   * @minLength 1
   */
  body: string;
  /** Represents the type of help request. */
  subject: APIHelpRequestType;
}

/** Represents the type of help request. */
export enum APIHelpRequestType {
  HelpWithApp = 'HelpWithApp',
  ReportIssue = 'ReportIssue',
  ProvideFeedback = 'ProvideFeedback',
  AccountIssue = 'AccountIssue',
  Other = 'Other',
  ConnectionIssue = 'ConnectionIssue',
}

export enum APIImportStatus {
  Exist = 'Exist',
  Imported = 'Imported',
  Error = 'Error',
}

export interface APIInt32TypeaheadModel {
  /**
   * The item id
   * @format int32
   */
  id?: number;
  /**
   * The name of an item
   * @example "TestName"
   */
  name?: null | string;
}

export interface APIInt32TypeaheadRequestModel {
  /** The value pattern to search */
  query?: null | string;
  /**
   * The number of result items to return
   * @format int32
   * @example 5
   */
  count?: number;
  /** Ids to exclude from search result */
  excludedIds?: null | any[];
}

export interface APIIntervalFilter {
  /**
   * The from value search parameter (searched from greater or equal value)
   * @format float
   */
  from?: null | number;
  /**
   * The from value search parameter (searched value less or equal to)
   * @format float
   */
  to?: null | number;
}

export interface APIKeystoneRequestModel {
  tickets?: null | any[];
}

export interface APIKeystoneTicketModel {
  code?: null | string;
  order_label?: null | string;
  plant_id?: null | string;
  asset_id?: null | string;
  /** @format double */
  primary_product_quantity?: number;
  company_id?: null | string;
  company_label?: null | string;
  /** @format int32 */
  is_cancelled?: number;
  plant_label?: null | string;
  project_id?: null | string;
  isVoided?: boolean;
  serviceName?: null | string;
}

export interface APILocation {
  /**
   * The Longitude of the location
   * @format double
   * @example 50.458902365376225
   */
  longitude?: number;
  /**
   * The Latitude of the location
   * @format double
   * @example 30.512978154738665
   */
  latitude?: number;
}

export interface APILocationAddress {
  /**
   * The Longitude of the location
   * @format double
   * @example 50.458902365376225
   */
  longitude?: number;
  /**
   * The Latitude of the location
   * @format double
   * @example 30.512978154738665
   */
  latitude?: number;
  /**
   * The physical address of location
   * @example "Kyiv. Honcharna St. 2, Kyiv, Ukraine 04071"
   */
  address?: null | string;
  /**
   * The name of location
   * @example "Honcharna"
   */
  name?: null | string;
}

export interface APILocationHistoryModel {
  /**
   * The id of the truck for the location history event
   * @format uuid
   */
  truckId: string;
  /**
   * The id of the user for the location history event
   * @format uuid
   */
  driverId?: null | string;
  /**
   * The longitude of the location history event
   * @format double
   */
  longitude?: number;
  /**
   * The latitude of the location history event
   * @format double
   */
  latitude?: number;
  /**
   * The id of the location history event
   * @format date-time
   */
  createdOn?: string;
}

export interface APILocationHistorySearchFilter {
  /**
   * The search parameter that indicates the start time of the date for start search period
   * @format time
   * @example "11:11"
   */
  timeFrom?: string;
  /**
   * The search parameter that indicates the end time of the date for start search period
   * @format time
   * @example "11:11"
   */
  timeTo?: string;
  /**
   * The search parameter that indicates the truck id for the search
   * @format uuid
   * @example "ef872317-4cd3-41a4-8d3a-2b6c744b4090"
   */
  truckId?: string;
  /**
   * The search parameter the date of the search
   * @format date
   */
  date?: string;
}

export interface APIMarkAsReadByUser {
  /** @format uuid */
  id?: string;
  name?: null | string;
  /** @format date-time */
  date?: string;
}

export interface APIMasterAdditiveModel {
  /**
   * The unique identifier of the additive
   * @format int32
   */
  id: number;
  /**
   * The name of the additive
   * @minLength 1
   */
  name: string;
  /**
   * The providerId of the additive
   * @format uuid
   */
  providerId: string;
  /**
   * Number of projects where additive is used
   * @format int32
   */
  assignment: number;
  /**
   * Number of completed orders where additive was used
   * @format int32
   */
  usage: number;
  /** Indicates that additive is project specific */
  isProjectSpecific: boolean;
  /**
   * The ID of the project where the additive is used, only for project specific additives
   * @format uuid
   */
  projectId?: null | string;
  /**
   * The ID of the company where the additive is used, only for project specific additives
   * @format uuid
   */
  companyId?: null | string;
  /** The categories associated with the additive */
  categories: APIMasterDataCategoryModel[];
}

export interface APIMasterAdditiveModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * The count of the searched entities in the DB
   * @format int32
   * @example 1
   */
  count?: number;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APIMasterAdditiveRequestModel {
  /**
   * The name of the additive.
   * @minLength 1
   */
  name: string;
  /** An array of category IDs associated with the additive. */
  categoryIds: number[];
  /**
   * A project for the additive, used for project specific additives
   * @format uuid
   */
  projectId?: null | string;
}

export interface APIMasterDataCategoryModel {
  /**
   * The unique identifier of the category.
   * @format int32
   */
  id: number;
  /**
   * The name of the category.
   * @minLength 1
   */
  name: string;
}

export interface APIMasterDataCategoryRequestModel {
  /**
   * The name of the category.
   * @minLength 1
   */
  name: string;
}

export interface APIMasterMixTypeModel {
  /**
   * The unique identifier of the mix type
   * @format int32
   */
  id: number;
  /**
   * The name of the mix type
   * @minLength 1
   */
  name: string;
  /**
   * The providerId of the mix type
   * @format uuid
   */
  providerId: string;
  /**
   * Number of projects where mix type is used
   * @format int32
   */
  assignment: number;
  /**
   * Number of completed orders where mix type was used
   * @format int32
   */
  usage: number;
  /** Indicates that mix type is project specific */
  isProjectSpecific: boolean;
  /**
   * The ID of the project where the mix type is used, only for project specific mixes
   * @format uuid
   */
  projectId?: null | string;
  /**
   * The ID of the company where the mix type is used, only for project specific mixes
   * @format uuid
   */
  companyId?: null | string;
  /** Collection of mix type categories */
  categories: APIMasterDataCategoryModel[];
}

export interface APIMasterMixTypeModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * The count of the searched entities in the DB
   * @format int32
   * @example 1
   */
  count?: number;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APIMasterMixTypeRequestModel {
  /**
   * The name of the mix type.
   * @minLength 1
   */
  name: string;
  /** An array of category IDs associated with the mix type. */
  categoryIds: number[];
  /**
   * A project for the mix type, used for project specific mixes
   * @format uuid
   */
  projectId?: null | string;
}

export interface APIMixTypeCompanyUsageModel {
  /**
   * The unique identifier of the company
   * @format uuid
   */
  id: string;
  /**
   * The name of the company
   * @minLength 1
   */
  name: string;
}

export interface APIMixTypeModel {
  /**
   * The unique identifier of the mix type
   * @format int32
   */
  id: number;
  /**
   * The name of the mix type
   * @minLength 1
   */
  name: string;
}

export interface APIMixTypeSearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: null | any[];
  /** The search parameter that indicates the Mix Type name to search */
  name?: null | string;
  /** The search parameter for the category to search */
  categoryIds?: null | any[];
  /** The search parameter that indicates if the mix type is project specific */
  isProjectSpecific?: boolean;
}

export interface APIMostUsedModel {
  /** @format int32 */
  percentage: number;
  usages: APIUsageModel[];
}

export interface APIMpaqDataModel {
  TicketNumber?: null | string;
  OrderID?: null | string;
  PlantID?: null | string;
  TruckID?: null | string;
  DriverID?: null | string;
  /** @format double */
  MixAmount?: number;
  /** @format date-time */
  ticketedTime?: string;
  /** @format date-time */
  loadedTime?: string;
  clientID?: null | string;
  mixID?: null | string;
  mixUnit?: null | string;
  projectID?: null | string;
  yardID?: null | string;
  isVoided?: boolean;
  serviceName?: null | string;
}

export interface APIMpaqRequestModel {
  event?: null | string;
  /** @format date-time */
  timestamp?: string;
  data?: APIMpaqDataModel;
}

export interface APIOrderAdditiveModel {
  /** @format int32 */
  id: number;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  originalName: string;
}

export interface APIOrderBatchNumberRequestModel {
  /**
   * The unique identifier of the order in batch system
   * @minLength 1
   * @example "test-order-1"
   */
  orderBatchNumber: string;
}

export interface APIOrderCallbackSubmitRequestModel {
  callBackFormStatus?: APICallBackFormStatus;
  /**
   * The volume of the callback requested
   * @format float
   */
  callbackFormVolume?: null | number;
  /**
   * Additional details for callback form
   * @minLength 1
   */
  additionalCallbackFormDetails?: string;
}

export interface APIOrderChangesRequestModel {
  orderStatus: APIOrderStatus;
  /**
   * Notes for the changes requested
   * @minLength 1
   * @example "Lorem ipsum dolor sit amet"
   */
  noteToCustomer: string;
  /** Shows if to confirm order upon approval of change request */
  confirmUponChangesApproval: boolean;
  /** Summary of changes that made to the order by the contractor */
  orderChanges: APIEntityHistoryModel[];
}

export interface APIOrderCustomFieldValue {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  value: string;
}

export interface APIOrderFieldCompanyModel {
  /** @format uuid */
  id: string;
  /** @minLength 1 */
  name: string;
}

export interface APIOrderFieldDefinitionModel {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  label: string;
  /** @minLength 1 */
  placeholder: string;
  type?: APICustomFieldType;
  companies?: null | any[];
}

export interface APIOrderFieldDefinitionRequestModel {
  /** @minLength 1 */
  label: string;
  /** @minLength 1 */
  placeholder: string;
  type?: APICustomFieldType;
  companyIds?: null | any[];
}

export interface APIOrderFieldsSchemaModel {
  /** @format uuid */
  id: string;
  /** @format int32 */
  version: number;
  /** @format date-time */
  createdOn: string;
  fields: APIOrderFieldDefinitionModel[];
}

export interface APIOrderFieldsSchemaRequestModel {
  fields: APIOrderFieldDefinitionRequestModel[];
}

export interface APIOrderImportModel {
  /**
   * The unique identifer of the order for the customer
   * @minLength 1
   * @example "test-order-1"
   */
  orderNumber: string;
  /**
   * The project name, where should be done delivery
   * @minLength 1
   * @example "Proxet project"
   */
  projectName: string;
  /**
   * The address where project is located
   * @minLength 1
   * @example "Kyiv. Honcharna St. 2, Kyiv, Ukraine 04071"
   */
  deliveryLocation: string;
  /**
   * The required delivery date for the order
   * @format date
   * @example "2022-11-11"
   */
  deliveryDate?: null | string;
  /**
   * The required delivery time fot the order
   * @format time
   * @example "11-11 AM"
   */
  deliveryTime?: null | string;
  /**
   * The volume of concrete that should be delivered
   * @format float
   * @example 11
   */
  volume: number;
  /**
   * The concrete mix type for the order
   * @minLength 1
   * @example "4000psi"
   */
  mixType: string;
  /**
   * The delivery rate of the order
   * @format float
   * @example 10
   */
  deliveryRate: number;
  /**
   * The elements to pouring for the order
   * @minLength 1
   * @example "Sidewalk"
   */
  jobDescription: string;
  /**
   * The contractor company name
   * @minLength 1
   */
  companyName: string;
  /**
   * The slump value of the concrete in the order.
   * The slump is a measure of the consistency of the concrete mix, and is expressed in inches.
   * @format double
   * @example 6.5
   */
  slump?: null | number;
  /**
   * The selected additives for the order
   * Should be separated by ',' symbol
   * @minLength 1
   * @example "Additive 1, Additive 2"
   */
  additives: string;
  /**
   * Notes for the order
   * @minLength 1
   * @example "Lorem ipsum dolor sit amet"
   */
  notes: string;
}

export interface APIOrderImportModelImportResult {
  model?: APIOrderImportModel;
  importStatus?: APIImportStatus;
  details?: null | any[];
}

export interface APIOrderMixTypeModel {
  /** @format int32 */
  id: number;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  originalName: string;
}

export interface APIOrderModel {
  /**
   * The unique identifier for the order in the cd3p system
   * @format int32
   * @example 1
   */
  id: number;
  orderStatus: APIOrderStatus;
  orderType: APIOrderType;
  /**
   * The unique identifier of the order for the customer
   * @minLength 1
   * @example "test-order-1"
   */
  orderNumber: string;
  /**
   * The order name
   * @minLength 1
   */
  orderName: string;
  /**
   * The providerId of the order
   * @format uuid
   */
  providerId: string;
  project: APIProjectModel;
  mixType: APIOrderMixTypeModel;
  /**
   * The address where project is located
   * @minLength 1
   * @example "Kyiv. Honcharna St. 2, Kyiv, Ukraine 04071"
   */
  deliveryLocation: string;
  /**
   * The Longitude of the project location
   * @format float
   * @example 50.458902365376225
   */
  longitude: number;
  /**
   * The Latitude of the project location
   * @format float
   * @example 30.512978154738665
   */
  latitude: number;
  /**
   * The required delivery date for the order
   * @format date
   * @example "2022-11-11"
   */
  deliveryDate: string;
  /**
   * The required delivery time fot the order
   * @format time
   * @example "11-11 AM"
   */
  deliveryTime: string;
  /**
   * The volume of concrete that should be delivered
   * @format float
   * @example 11
   */
  volume: number;
  /**
   * The original volume of concrete that should be delivered
   * @format float
   * @example 11
   */
  originalVolume?: number;
  /**
   * The total of drivers/tickets concrete which are currently in Delivering/On-Site states
   * @format float
   * @example 10
   */
  batched?: number;
  /**
   * The total of drivers (trucks) concrete quantity that left the job site
   * @format float
   * @example 10
   */
  delivered?: number;
  /**
   * The delivery rate of the order
   * @format float
   * @example 10
   */
  deliveryRate: number;
  /**
   * The Actual computed delivery rate of the order
   * @format float
   * @example 10
   */
  actualDeliveryRate: number;
  deliveryRateType: APIDeliveryRateType;
  /**
   * eThe elements to pouring for the order
   * @minLength 1
   * @example "Sidewalk"
   */
  jobDescription: string;
  /**
   * Shows when order was created
   * @format date-time
   */
  createdDate?: null | string;
  /**
   * The user who created the order
   * @minLength 1
   */
  requestedConfirmedBy: string;
  company: APICompanyModel;
  /**
   * The date time which shows when dispatcher confirm order and send notification to user
   * @format date-time
   */
  notificationSentDate?: null | string;
  /**
   * The date time which shows when user either confirm or reject order
   * @format date-time
   */
  confirmationRequestDate?: null | string;
  /**
   * The total ticket count that was created for the order
   * @format int32
   */
  ticketsCount: number;
  /** The Flag indicating that all order tickets completed and order status can be updated to completed */
  pendingCompletion: boolean;
  /**
   * Notes for the order
   * @minLength 1
   * @example "Lorem ipsum dolor sit amet"
   */
  notes: string;
  /**
   * The slump value of the concrete in the order.
   * The slump is a measure of the consistency of the concrete mix, and is expressed in inches.
   * @format double
   * @example 6.5
   */
  slump?: null | number;
  /** Indicates whether there are any changes on the requested status of the order */
  hasChangesOnRequestedState: boolean;
  /** The list of available additives selected for the order */
  additives: APIOrderAdditiveModel[];
  /**
   * The third party id of the order
   * @minLength 1
   */
  thirdPartyId: string;
  /** Summary of changes that made to the order by the contractor */
  orderChanges: APIEntityHistoryModel[];
  /** Flag indicating that Batch Number reminder was reviewed by the user */
  isBatchNumberReminderSubmitted: boolean;
  /** Flag indicating that changes requested on the order */
  isChangesRequested: boolean;
  /** Shows whether this order was read by the dispatcher or not */
  isReadByDispatcher: boolean;
  /** Will allow to close orders automatically */
  callBack: boolean;
  callBackFormStatus: APICallBackFormStatus;
  /**
   * The volume of the callback requested
   * @format float
   */
  callbackFormVolume?: null | number;
  /**
   * Additional details for callback form
   * @minLength 1
   */
  additionalCallbackFormDetails: string;
  /** Shows whether user subscribed to order notifications or not */
  isUserSubscribed: boolean;
  dialog: APIDialogModel;
  /** Shows if order cancellation request was submitted */
  isCancellationSubmitted: boolean;
  /** Shows if to confirm order upon approval of change request */
  confirmUponChangesApproval: boolean;
  /**
   * Field to describe what is being poured
   * @minLength 1
   */
  typeOfPour: string;
  /**
   * Field to describe how concrete will be placed
   * @minLength 1
   */
  placementMethod: string;
  /** Shows order highlights */
  highlights: Record<string, null | any[]>;
  /** The list of project subscribed users */
  subscribedUsers: APISubscribedUserModel[];
  /** The list of custom field values */
  customFieldValues: APIOrderCustomFieldValue[];
  orderFieldsSchema: APIOrderFieldsSchemaModel;
}

export interface APIOrderModelPositionElement {
  /**
   * The position of the element in the list
   * @format int32
   */
  position?: number;
  element?: APIOrderModel;
}

export interface APIOrderModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * The count of the searched entities in the DB
   * @format int32
   * @example 1
   */
  count?: number;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APIOrderRequestModel {
  /**
   * The unique identifer of the order for the customer
   * @minLength 1
   * @example "test-order-1"
   */
  orderNumber: string;
  /** The order name */
  orderName?: null | string;
  /**
   * The required delivery date for the order
   * @format date
   * @example "2022-11-11"
   */
  deliveryDate?: null | string;
  /**
   * The address where project is located
   * @minLength 1
   * @example "Kyiv. Honcharna St. 2, Kyiv, Ukraine 04071"
   */
  deliveryLocation: string;
  /**
   * The Longitude of the project location
   * @format float
   * @example 50.458902365376225
   */
  longitude?: null | number;
  /**
   * The Latitude of the project location
   * @format float
   * @example 30.512978154738665
   */
  latitude?: null | number;
  /**
   * The required delivery time fot the order
   * @format time
   * @example "11:11"
   */
  deliveryTime?: null | string;
  /**
   * The volume of concrete that should be delivered
   * @format float
   * @example 11
   */
  volume: number;
  /**
   * The type of concrete that should be delivered
   * @format int32
   */
  mixTypeId: number;
  /**
   * The delivery rate of the order
   * @format float
   * @example 10
   */
  deliveryRate: number;
  deliveryRateType: APIDeliveryRateType;
  /**
   * The type of the pouring mode
   * @minLength 1
   * @example "Direct"
   */
  pouringMode: string;
  /**
   * eThe elements to pouring for the order
   * @minLength 1
   * @example "Sidewalk"
   */
  jobDescription: string;
  /**
   * The company project id
   * @format uuid
   */
  projectId: string;
  orderStatus: APIOrderStatus;
  orderType: APIOrderType;
  /**
   * The date time which shows when dispatcher confirm order and send notification to user
   * @format date-time
   */
  notificationSentDate?: null | string;
  /**
   * The date time which shows when user either confirm or reject order
   * @format date-time
   */
  confirmationRequestDate?: null | string;
  /**
   * Notes for the order
   * @example "Lorem ipsum dolor sit amet"
   */
  notes?: null | string;
  /**
   * Notes for the changes requested
   * @example "Lorem ipsum dolor sit amet"
   */
  noteToCustomer?: null | string;
  /**
   * The slump value of the concrete in the order.
   * The slump is a measure of the consistency of the concrete mix, and is expressed in inches.
   * @format double
   * @example 6.5
   */
  slump?: null | number;
  /** The list of selected additives for the order */
  additives: APIAdditiveRequestModel[];
  /** Flag indicating that Batch Number reminder was reviewed by the user */
  isBatchNumberReminderSubmitted?: boolean;
  /** Flag indicating that changes requested on the order */
  isChangesRequested?: boolean;
  /** Will allow to close orders automatically */
  callBack: boolean;
  callBackFormStatus?: APICallBackFormStatus;
  /**
   * The volume of the callback requested
   * @format float
   */
  callbackFormVolume?: null | number;
  /** Additional details for callback form */
  additionalCallbackFormDetails?: null | string;
  /** Shows if order update should notify contractor by showing popup notification. */
  shouldNotifyContractor?: null | boolean;
  /** Shows if order cancellation request was submitted */
  isCancellationSubmitted?: null | boolean;
  /** Shows if to confirm order upon approval of change request */
  confirmUponChangesApproval?: boolean;
  /**
   * Field to describe what is being poured
   * @minLength 1
   */
  typeOfPour: string;
  /**
   * Field to describe how concrete will be placed
   * @minLength 1
   */
  placementMethod: string;
  /** The unique identifiers of the users to be subscribed to order */
  subscribedUsersIds?: null | any[];
  /**
   * The id of the order fields schema
   * @format uuid
   */
  orderFieldsSchemaId?: null | string;
  /** The list of custom order fields */
  customFieldValues?: null | any[];
}

export interface APIOrderSearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: null | any[];
  fullTextSearch?: APIFullTextSearchFilter;
  /**
   * The search parameter that indicates the start search period for the order
   * @format date-time
   */
  dateFrom?: null | string;
  /**
   * The search parameter that indicates the end search period for the order
   * @format date-time
   */
  dateTo?: null | string;
  /** The search parameter that indicates the end search period for the order */
  orderNumber?: null | string;
  /** The search parameter for the array of the volumes of the order */
  volume?: null | any[];
  /** The search parameter for the order status */
  orderStatuses?: null | any[];
  /** The array of the search order ids */
  orderIds?: null | any[];
  /** The search parameter for the ids of the company for which order was created */
  companyIds?: null | any[];
  /** The search parameter for project ids */
  projectIds?: null | any[];
  /** Filters orders with cancellation request submitted */
  isCancellationSubmitted?: null | boolean;
  /** Filter on orders where current user subscribed */
  isUserSubscribed?: null | boolean;
}

export enum APIOrderStatus {
  Requested = 'Requested',
  Unconfirmed = 'Unconfirmed',
  Declined = 'Declined',
  Confirmed = 'Confirmed',
  Cancelled = 'Cancelled',
  Delivering = 'Delivering',
  Completed = 'Completed',
}

export interface APIOrderSubscriptionModel {
  /** @format int32 */
  orderId: number;
  /** @format date-time */
  createdOn: string;
  /** @format date-time */
  updatedOn: string;
  /** @format int64 */
  ticks: number;
  isDeleted?: boolean;
}

export interface APIOrderSubscriptionRequestModel {
  /** The unique identifiers of the users to be subscribed to order */
  subscribedUsersIds: string[];
}

export interface APIOrderSubscriptionsFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: null | any[];
  /**
   * The period of time to search for subscriptions when the subscription was updated
   * @format date-time
   */
  updateOn?: null | string;
  /** Search for subscriptions by order ids */
  orderIds?: null | any[];
  /** Flag that shows returns only active subscriptions */
  onlyActive?: boolean;
}

export enum APIOrderType {
  WillCall = 'WillCall',
  FirmOrder = 'FirmOrder',
}

export interface APIPlantModel {
  /**
   * The unique identifier for the plant
   * @format uuid
   */
  id: string;
  /**
   * The address where plant is located
   * @minLength 1
   * @example "Kyiv. Honcharna St. 2, Kyiv, Ukraine 04071"
   */
  address: string;
  /**
   * The name of a plant
   * @minLength 1
   * @example "Best Plant"
   */
  name: string;
  /**
   * The Longitude of the plant location
   * @format float
   * @example 50.458902365376225
   */
  longitude: number;
  /**
   * The Latitude of the plant location
   * @format float
   * @example 30.512978154738665
   */
  latitude: number;
  /**
   * The third party id of the plant
   * @minLength 1
   */
  thirdPartyId: string;
  /**
   * The radius of the plant
   * @format int32
   */
  plantRadius?: null | number;
  /** Geo fence coordinates */
  geoFenceCoordinates?: null | any[];
}

export interface APIPlantModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * The count of the searched entities in the DB
   * @format int32
   * @example 1
   */
  count?: number;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APIPlantRequestModel {
  /**
   * The address where plant is located
   * @minLength 1
   * @example "Kyiv. Honcharna St. 2, Kyiv, Ukraine 04071"
   */
  address: string;
  /**
   * The name of a plant
   * @minLength 1
   * @example "Best Plant"
   */
  name: string;
  /** The third party id of the plant */
  thirdPartyId?: null | string;
  /**
   * The Longitude of the location
   * @format float
   * @example 50.458902365376225
   */
  longitude?: null | number;
  /**
   * The Latitude of the location
   * @format float
   * @example 30.512978154738665
   */
  latitude?: null | number;
  /**
   * The radius of the plant
   * @format int32
   */
  plantRadius?: null | number;
  /** The coordinates of the plant */
  geoFenceCoordinates?: null | any[];
}

export interface APIPlantSearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: null | any[];
  name?: null | string;
  address?: null | string;
  providerName?: null | string;
}

export interface APIPlantUpdateRequestModel {
  /**
   * The name of a plant
   * @minLength 1
   * @example "Best Plant Ever"
   */
  name: string;
  /** The third party id of the plant */
  thirdPartyId?: null | string;
  /**
   * The radius of the plant
   * @format int32
   */
  plantRadius?: null | number;
  /**
   * The Longitude of the location
   * @format double
   * @example 50.458902365376225
   */
  longitude?: null | number;
  /**
   * The Latitude of the location
   * @format double
   * @example 30.512978154738665
   */
  latitude?: null | number;
  /** Geo fence coordinates */
  geoFenceCoordinates?: null | any[];
}

export interface APIProjectAdditiveRequestModel {
  /** The unique identifiers of the additives */
  ids: number[];
}

export interface APIProjectMixTypeRequestModel {
  /** The unique identifiers of the mix types */
  ids: number[];
}

export interface APIProjectModel {
  /**
   * The unique identifier for project
   * @format uuid
   */
  id: string;
  /**
   * The project name, where should be done delivery
   * @minLength 1
   */
  name: string;
  projectStatus: APIProjectStatus;
  company: APICompanyModel;
  /**
   * The address where the project is located
   * @minLength 1
   */
  address: string;
  /**
   * The delivery address
   * @minLength 1
   */
  deliveryAddress: string;
  /**
   * The Longitude of the project location
   * @format float
   */
  longitude: number;
  /**
   * The Latitude of the project location
   * @format float
   */
  latitude: number;
  /**
   * Shows when project was created
   * @format date-time
   */
  createdDate?: null | string;
  /** Field that shows whether project is used by someone or not */
  inUse?: boolean;
  /** Field that shows whether project has orders in active statuses */
  hasActiveOrders?: boolean;
  /**
   * The total orders count that was created for the project
   * @format int32
   */
  ordersCount?: number;
  /** The list of available mix types for the project */
  mixTypes: APIMixTypeModel[];
  /** The list of available additives for the project */
  additives: APIAdditiveModel[];
  /** Shows if project is deleted */
  isDeleted: boolean;
  /**
   * Project description
   * @minLength 1
   */
  description: string;
  /** The list of project options */
  projectOptions: Record<string, null | string>;
  /** The list of project subscribed users */
  subscribedUsers: APISubscribedUserModel[];
}

export interface APIProjectModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * The count of the searched entities in the DB
   * @format int32
   * @example 1
   */
  count?: number;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APIProjectRequestModel {
  /**
   * The project name, where should be done delivery
   * @minLength 1
   */
  name: string;
  /** The address where the project is located */
  address?: null | string;
  /** The delivery address */
  deliveryAddress?: null | string;
  /**
   * The longitude of the project location or delivery,
   * Required if Delivery Address provided
   * @format float
   */
  longitude?: null | number;
  /**
   * The latitude of the project location or delivery
   * Required if Delivery Address provided
   * @format float
   */
  latitude?: null | number;
  /**
   * The company id of the project
   * @format uuid
   */
  companyId: string;
  projectStatus: APIProjectStatus;
  /** Project description */
  description?: null | string;
  /** Flag that indicates that the project contains custom mix types */
  isCustomMixTypes?: boolean;
  /** Flag that indicates that the project contains custom additives */
  isCustomAdditives?: boolean;
  /** The unique identifiers of the users to be subscribed to project */
  subscribedUsersIds?: null | any[];
}

export interface APIProjectSearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: null | any[];
  /** The search parameter for the name and address of the project */
  keyword?: null | string;
  /** The array of the search project ids */
  projectIds?: null | any[];
  /** The search parameter for the ids of the company for which project was created */
  companyIds?: null | any[];
  /** The search parameter which show what kind of project should be return by status */
  projectStatuses?: null | any[];
}

export enum APIProjectStatus {
  Active = 'Active',
  Archived = 'Archived',
}

export interface APIProjectSubscriptionRequestModel {
  /** The unique identifiers of the users */
  subscribedUsersIds: string[];
}

export interface APIProjectTypeaheadRequestModel {
  /** The value pattern to search */
  query?: null | string;
  /**
   * The number of result items to return
   * @format int32
   * @example 5
   */
  count?: number;
  /** Ids to exclude from search result */
  excludedIds?: null | any[];
  /**
   * The search parameter for the company id
   * @format uuid
   */
  companyId?: string;
  /** Indicates that projects without mixes should be included in the results */
  includeProjectsWithoutMixes?: boolean;
}

export interface APIProviderAdminRequestModel {
  /**
   * The email of the provider admin.
   * @minLength 1
   */
  email: string;
  /**
   * The first name of the provider admin.
   * @minLength 1
   */
  firstName: string;
  /**
   * The last name of the provider admin.
   * @minLength 1
   */
  lastName: string;
}

export enum APIProviderIntegrationStatus {
  Failed = 'Failed',
  Offline = 'Offline',
  Online = 'Online',
  NotStarted = 'NotStarted',
}

export interface APIProviderIntegrationStatusModel {
  /** @format uuid */
  providerId: string;
  integrationType: APIProviderIntegrationType;
  status: APIProviderIntegrationStatus;
  /** @format date-time */
  lastSyncDate?: null | string;
  /** @format int32 */
  errorTryCount?: null | number;
}

export enum APIProviderIntegrationType {
  Ticket = 'Ticket',
  Gps = 'Gps',
}

export interface APIProviderModel {
  /**
   * The unique identifier of the provider
   * @format uuid
   * @example "5fba66db-dd49-4653-9f8a-7d79e51e6e9f"
   */
  id: string;
  /**
   * The name of the provider
   * @minLength 1
   * @example "Test provider"
   */
  providerName: string;
  /**
   * The address of provider's office
   * @example "Kyiv. Honcharna St. 2, Kyiv, Ukraine 04071"
   */
  officeAddress?: null | string;
  /**
   * The Longitude of the project location
   * @format float
   * @example 50.458902365376225
   */
  longitude?: number;
  /**
   * The Latitude of the project location
   * @format float
   * @example 30.512978154738665
   */
  latitude?: number;
  /**
   * The Latitude of the providers middle location
   * @format double
   */
  centroidLatitude?: number;
  /**
   * The Longitude of the providers middle location
   * @format double
   */
  centroidLongitude?: number;
  /** Indicates if the provider is deactivated */
  isDeactivated?: boolean;
  /**
   * The phone number of the provider company
   * @example "+18571234675"
   */
  phone?: null | string;
  /**
   * The date when the provider was created
   * @format date-time
   */
  createdOn?: string;
}

export interface APIProviderModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * The count of the searched entities in the DB
   * @format int32
   * @example 1
   */
  count?: number;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APIProviderRequestModel {
  /**
   * The name of the provider
   * @minLength 1
   * @example "Test provider"
   */
  providerName: string;
  /**
   * The address of provider's office
   * @example "Kyiv. Honcharna St. 2, Kyiv, Ukraine 04071"
   */
  officeAddress?: null | string;
  /**
   * The phone number of the provider company
   * @example "+18571234675"
   */
  phone?: null | string;
  /** Is provider deactivated */
  isDeactivated?: boolean;
}

export interface APIProviderSearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: null | any[];
  /**
   * The search parameter for provider name (search by start with condition)
   * @example "bostone concrete"
   */
  providerName?: null | string;
  /**
   * Include inactive providers
   * @example true
   */
  includeDeactivated?: boolean;
}

export interface APIProviderSettingsModel {
  /**
   * The name of a setting
   * @minLength 1
   * @example "SendFromPhone"
   */
  key: string;
  /**
   * Setting value
   * @minLength 1
   * @example "+18574474475"
   */
  value: string;
}

export interface APIProviderSettingsRequestModel {
  providerSettings?: null | any[];
}

export interface APISearchSortOrder {
  /**
   * The name of a sort field
   * @default "Id"
   * @example "OrderNumber"
   */
  sortField?: null | string;
  sortOrder?: APISortOrder;
}

export interface APISensitiveDataResponseStatus {
  isApproved?: boolean;
}

export enum APISortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface APISubscribedUserModel {
  /** @format uuid */
  id: string;
  /** @minLength 1 */
  firstName: string;
  /** @minLength 1 */
  lastName: string;
  /** @minLength 1 */
  email: string;
}

export interface APITemporaryTokenModel {
  token?: null | string;
}

export enum APITicketEventCode {
  TicketCreated = 'TicketCreated',
  TicketAssigned = 'TicketAssigned',
  BeginLoad = 'BeginLoad',
  ToJob = 'ToJob',
  ArriveJob = 'ArriveJob',
  BeginPour = 'BeginPour',
  StopPour = 'StopPour',
  ToYard = 'ToYard',
  ProductAdd = 'ProductAdd',
  Completed = 'Completed',
  Updated = 'Updated',
  TicketVoid = 'TicketVoid',
  LoadComplete = 'LoadComplete',
  ArrivePickup = 'ArrivePickup',
  DelayAtJob = 'DelayAtJob',
  TruckAssigned = 'TruckAssigned',
  ToPickup = 'ToPickup',
  Deactivate = 'Deactivate',
  PausePour = 'PausePour',
  ResumePour = 'ResumePour',
}

export interface APITicketModel {
  /**
   * The unique identifier for the ticket in the cd3p system
   * @format int32
   * @example 1
   */
  id: number;
  /**
   * Ticket number
   * @minLength 1
   * @example "test"
   */
  ticketNumber: string;
  driver?: APIUserModel;
  truck: APITruckModel;
  plant: APIPlantModel;
  order: APIOrderModel;
  company: APICompanyModel;
  project: APIProjectModel;
  /**
   * The Longitude of the project location
   * @format float
   */
  longitude: number;
  /**
   * The Latitude of the project location
   * @format float
   */
  latitude: number;
  /**
   * The address where project is located
   * @minLength 1
   */
  deliveryLocation: string;
  /**
   * Order Id associated with ticket
   * @format int32
   */
  orderId: number;
  /**
   * Order Number associated with ticket
   * @minLength 1
   */
  orderNumber: string;
  /** Order Name associated with ticket */
  orderName?: null | string;
  /**
   * Q-ty of concrete
   * @format float
   */
  batchSize: number;
  /**
   * Total on Delivery 1st ticket batch_size + … + n ticket+batcр_size
   * @format float
   */
  totalOnDelivery: number;
  ticketStatus: APITicketStatus;
  /**
   * Date and time when ticket was created
   * @format date-time
   */
  createdDate: string;
  /**
   * Date and time when delivery was made
   * @format date-time
   */
  deliveryArrivalTime: string;
  /**
   * Text with cancellation reason of a ticket
   * @example "Ordered by mistake "
   */
  cancellationReasonComment?: null | string;
  /** History of ticket status changes */
  ticketStatusHistory: APITicketStatusHistoryModel[];
}

export interface APITicketModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * The count of the searched entities in the DB
   * @format int32
   * @example 1
   */
  count?: number;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APITicketRequestModel {
  /**
   * Ticket number
   * @minLength 1
   * @example "test"
   */
  ticketNumber: string;
  /**
   * Truck id assigned to ticket
   * @format uuid
   */
  truckId?: null | string;
  /**
   * Driver id assigned to ticket
   * @format uuid
   */
  driverId?: null | string;
  /**
   * Plant id for ticket
   * @format uuid
   */
  plantId?: null | string;
  /**
   * Project id for ticket
   * @format uuid
   */
  projectId?: null | string;
  /**
   * Q-ty of concrete
   * @format float
   */
  batchSize: number;
  ticketStatus: APITicketStatus;
  /**
   * Text with cancellation reson of a ticket
   * @example "Ordered by mistake "
   */
  cancellationReasonComment?: null | string;
}

export interface APITicketSearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: null | any[];
  /**
   * The search parameter for the ticket number (search by contains condition)
   * @example "test"
   */
  ticketNumber?: null | string;
  ticketStatuses?: null | any[];
  /**
   * The search parameter for the ticket driver id
   * @format uuid
   */
  driverId?: null | string;
  /**
   * The search parameter for the ticket truck id
   * @format uuid
   */
  truckId?: null | string;
  /**
   * The search parameter for the ticket plant
   * @format uuid
   */
  plantId?: null | string;
  /**
   * The search parameter for the ticket order
   * @format int32
   * @example "test"
   */
  orderId?: null | number;
  /**
   * The search parameter for the batch size
   * @format double
   * @example 1
   */
  batchSize?: number;
  /**
   * The search parameter that indicates the start search period for the ticket
   * @format date-time
   */
  dateFrom?: null | string;
  /**
   * The search parameter that indicates the end search period for the ticket
   * @format date-time
   */
  dateTo?: null | string;
  /** The search parameter that indicates that the driver is assigned to the ticket */
  hasAssignedDriver?: null | boolean;
  /**
   * The search parameter that indicates that total on delivery should be calculated,
   * Works only if all required statuses are in the result
   */
  calculateTotalOnDelivery?: boolean;
}

export enum APITicketStatus {
  Draft = 'Draft',
  Loading = 'Loading',
  Delivering = 'Delivering',
  OnSite = 'OnSite',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  Pending = 'Pending',
}

export enum APITicketStatusCode {
  TicketCreated = 'TicketCreated',
  Ticketed = 'Ticketed',
  Loading = 'Loading',
  ToJob = 'ToJob',
  Waiting = 'Waiting',
  Pouring = 'Pouring',
  Returning = 'Returning',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  ArrivePickup = 'ArrivePickup',
  Loaded = 'Loaded',
  Poured = 'Poured',
  TruckAssigned = 'TruckAssigned',
  ToPickup = 'ToPickup',
}

export interface APITicketStatusHistoryModel {
  ticketStatus: APITicketStatus;
  /**
   * The timestamp when the status was changed.
   * @format date-time
   */
  timeStamp: string;
  /** The flag indicating that the change was done manually */
  isManualChange: boolean;
}

export enum APITicketType {
  StandardTicket = 'StandardTicket',
  QuickRouteTicket = 'QuickRouteTicket',
}

export interface APITimeOfArrivalModel {
  /** @format int32 */
  duration: number;
  /** @format int32 */
  distance?: number;
  /** @format date-time */
  lastUpdated: string;
  lastLocation: APILocation;
}

export interface APITimeZonesModel {
  /** @minLength 1 */
  countryName: string;
  /** @minLength 1 */
  countryCode: string;
  /** @minLength 1 */
  zoneId: string;
  /** @minLength 1 */
  zoneName: string;
  /** @minLength 1 */
  offset: string;
}

export interface APITrackEmulateModel {
  /**
   * The Id of a truck
   * @format uuid
   */
  truckId?: string;
  /**
   * Delay
   * @format int32
   */
  delay?: number;
  /** Truck Number */
  trackName?: null | string;
  /**
   * File with tracking info
   * @format binary
   */
  file?: null | string;
}

export interface APITrackModel {
  name?: null | string;
}

export interface APITruckGpsModel {
  /** @minLength 1 */
  deviceId: string;
  /** @minLength 1 */
  truckNumber: string;
  /** @format uuid */
  syncedTruckId?: null | string;
  truckOperationalStatus?: APITruckOperationalStatus;
}

export interface APITruckLocationModel {
  /**
   * Truck number.
   * @minLength 1
   * @example "308"
   */
  truckNumber: string;
  /**
   * GPS track device identifier associated with the truck.
   * @minLength 1
   */
  gpsTrackDeviceId: string;
  /**
   * Unique identifier for the truck.
   * @minLength 1
   */
  truckId: string;
  /** Identifier for the driver of the truck. */
  driverId?: null | string;
  /** The first name of the driver. */
  driverFirstName?: null | string;
  /** The last name of the driver. */
  driverLastName?: null | string;
  /** GPS tracking identifier for the driver. */
  driverGpsTrackingId?: null | string;
  /**
   * Associated ticket.
   * @format int32
   */
  ticketId?: null | number;
  /**
   * Associated companyId
   * @format uuid
   */
  companyId?: null | string;
  /** Ticket number associated with the truck. */
  ticketNumber?: null | string;
  /** Project name associated with the truck. */
  projectName?: null | string;
  /** Plant name associated with the truck. */
  plantName?: null | string;
  /**
   * Unique identifier for the associated order.
   * @format int32
   */
  orderId?: null | number;
  timeOfArrival?: APITimeOfArrivalModel;
  currentLocation: APILocation;
  plantLocation: APILocation;
  deliveryLocation: APILocation;
  truckStatus: APITruckStatus;
  /** Flag indicating whether the truck is online. */
  isOnline?: boolean;
  /**
   * The timestamp of the last update for the truck's information.
   * @format date-time
   */
  lastUpdate: string;
  /** Delivery address associated with the truck. */
  deliveryAddress?: null | string;
  /**
   * Shared with provider id.
   * @format uuid
   */
  sharedToProviderId?: null | string;
}

export interface APITruckLocationRequestModel {
  /** @minLength 1 */
  truckNumber: string;
  driverFirstName?: null | string;
  driverLastName?: null | string;
  timeOfArrival?: APITimeOfArrivalModel;
  /** @format int32 */
  orderId?: null | number;
  /** @format uuid */
  truckId?: string;
  /** @format uuid */
  driverId?: null | string;
  /** @format int32 */
  ticketId?: null | number;
  plantId?: null | string;
  plantName?: null | string;
  projectName?: null | string;
  currentLocation: APILocation;
  plantLocation?: APILocation;
  deliveryLocation?: APILocation;
  gpsTrackDeviceId?: null | string;
  /** @format uuid */
  sharedToProviderId?: null | string;
  truckStatus?: APITruckStatus;
}

export interface APITruckModel {
  /**
   * The unique identifier for the truck
   * @format uuid
   * @example "628ffc50-56c7-4b30-a752-9d9438cbc51a"
   */
  id: string;
  /**
   * The truck number of the truck
   * @minLength 1
   * @example "308"
   */
  truckNumber: string;
  /**
   * Date and time of last truck update
   * @format date-time
   */
  lastUpdate: string;
  /** Status of truck */
  isOnline: boolean;
  driver?: APIUserModel;
  /** License Plate */
  licensePlate?: null | string;
  /** The third party id of the truck */
  gpsThirdPartyId?: null | string;
  /** Ticketing third party id */
  ticketingThirdPartyId?: null | string;
  /** Indicates whether truck is deleted */
  isDeleted?: boolean;
  /**
   * The provider id
   * @format uuid
   */
  providerId: string;
}

export interface APITruckModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * The count of the searched entities in the DB
   * @format int32
   * @example 1
   */
  count?: number;
  /** The list of the searched entities */
  result?: null | any[];
}

export enum APITruckOperationalStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Deactivated = 'Deactivated',
}

export interface APITruckRequestModel {
  /**
   * The truck number of the truck
   * @minLength 1
   * @example "308"
   */
  truckNumber: string;
  /**
   * The truck third party id
   * @example 308
   */
  gpsThirdPartyId?: null | string;
  /** The ticketing system third party id */
  ticketingThirdPartyId?: null | string;
  /**
   * The driver id associated with the truck
   * @format uuid
   */
  driverId?: null | string;
}

export interface APITruckSearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: null | any[];
  /**
   * The search parameter for truck number (search by start with condition)
   * @example 308
   */
  truckNumber?: null | string;
  /** The search parameters for truck ids */
  truckIds?: null | any[];
  /** Indicates if truck is free for driver assign */
  isFreeForDriverAssign?: boolean;
  /** Indicates if truck has assigned tickets */
  hasNoTickets?: boolean;
}

export enum APITruckStatus {
  Unavailable = 'Unavailable',
  Ready = 'Ready',
  Loading = 'Loading',
  Delivering = 'Delivering',
  OnSite = 'OnSite',
  Returning = 'Returning',
}

export interface APITruckTrackingFilter {
  truckStatuses?: null | any[];
  /** @format int32 */
  orderId?: null | number;
  truckId?: null | any[];
}

export interface APIUsageModel {
  /**
   * The unique identifier of the mix type
   * @format int32
   */
  id: number;
  /**
   * The name of the mix type
   * @minLength 1
   */
  name: string;
  /**
   * The number of orders using the mix type
   * @format int32
   */
  usage: number;
}

export interface APIUsageModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * The count of the searched entities in the DB
   * @format int32
   * @example 1
   */
  count?: number;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APIUserAuthModel {
  email?: null | string;
  password?: null | string;
}

export interface APIUserModel {
  /**
   * The unique identifier for the user
   * @format uuid
   * @example "628ffc50-56c7-4b30-a752-9d9438cbc51a"
   */
  id: string;
  /**
   * The first name of the user
   * @minLength 1
   * @example "Alex"
   */
  firstName: string;
  /**
   * The last name of the user
   * @minLength 1
   * @example "Stock"
   */
  lastName: string;
  /**
   * The email address of the user which will be used for login, should be unique
   * @minLength 1
   * @example "alex.stock@cd3p.app"
   */
  email: string;
  /**
   * The phone number of the user which will be for notifications
   * @minLength 1
   * @example "+18571234675"
   */
  phone: string;
  userType: APIUserType;
  userStatus?: APIUserStatus;
  accessLevel: APIAccessLevel;
  /** The list of providers for which user has access */
  providers?: null | any[];
  /** The list of companies where the user belongs */
  companies?: null | any[];
  /** The third party id of the user */
  thirdPartyId?: null | string;
  /** The gps tracking system id of the user */
  gpsTrackingId?: null | string;
  /** The token for authorization */
  token?: null | string;
  /** The temporary token for authorization */
  temporaryToken?: null | string;
  /** Version of cache stored on the user device */
  globalCacheVersion?: null | string;
  /** The list of user options */
  userOptions?: null | object;
  newApplicationVersions?: null | any[];
}

export interface APIUserModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * The count of the searched entities in the DB
   * @format int32
   * @example 1
   */
  count?: number;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APIUserRequestModel {
  /**
   * The first name of the user
   * @example "Alex"
   */
  firstName?: null | string;
  /**
   * The last name of the user
   * @example "Stock"
   */
  lastName?: null | string;
  /**
   * The email address of the user which will be used for login, should be unique
   * @minLength 1
   * @example "alex.stock@cd3p.app"
   */
  email: string;
  /**
   * The phone number of the user which will be used for notifications
   * @example "+18571234675"
   */
  phone?: null | string;
  /**
   * The user's password in the system
   * @example "Qwerty123"
   */
  password?: null | string;
  accessLevel: APIAccessLevel;
  userType: APIUserType;
  userStatus: APIUserStatus;
  /** The list of providers for which user has access */
  providerIds: string[];
  /** The ids of existing companies to add user to during registration */
  companyIds?: null | any[];
  /** The user id in the third party system */
  thirdPartyId?: null | string;
  /** Indicates whether the verification of company information is required during the registration process. */
  shouldVerifyCompanyInfo?: boolean;
  /** Indicates whether the user has access to the web application */
  hasAccessToMobileApp?: boolean;
  /** Pass true if u want to ignore user exist exeption, false by default */
  shouldIgnoreUserExistException?: boolean;
}

export interface APIUserSearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: null | any[];
  /** Gets or sets a value indicating whether the search should include results from multiple providers. */
  crossProviderSearch?: boolean;
  /** The search parameter for query string, searches by first, last and email */
  query?: null | string;
  /** Ids to exclude from search result */
  excludedIds?: null | any[];
  /**
   * The search parameter for user first name (search by start with condition)
   * @example "alex"
   */
  firstName?: null | string;
  /**
   * The search parameter for user last name (search by start with condition)
   * @example "stock"
   */
  lastName?: null | string;
  /**
   * The search parameter for user email (search by start with condition)
   * @example "alex@st"
   */
  email?: null | string;
  /**
   * The search parameter for user phone (search by start with condition)
   * @example "+123"
   */
  phone?: null | string;
  /** The search parameter for the user status */
  userStatuses?: null | any[];
  /**
   * The list of provider where searched user is located
   * @example "stock"
   */
  providerIds?: null | any[];
  /** The search parameter for the ids of the company for which user was created */
  companyIds?: null | any[];
  userType?: APIUserType;
  /** Show deleted users in user search */
  includeDeleted?: null | boolean;
}

export enum APIUserStatus {
  Deactivated = 'Deactivated',
  NotActive = 'NotActive',
  Incomplete = 'Incomplete',
  Active = 'Active',
  PendingTermsAcceptance = 'PendingTermsAcceptance',
  PendingTermsAcceptanceOnly = 'PendingTermsAcceptanceOnly',
}

export enum APIUserType {
  Dispatcher = 'Dispatcher',
  Driver = 'Driver',
  Contractor = 'Contractor',
  Support = 'Support',
}
